import { render, staticRenderFns } from "./MinorProtection.vue?vue&type=template&id=5899eb5a&scoped=true"
import script from "./MinorProtection.vue?vue&type=script&lang=ts"
export * from "./MinorProtection.vue?vue&type=script&lang=ts"
import style0 from "./MinorProtection.vue?vue&type=style&index=0&id=5899eb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899eb5a",
  null
  
)

export default component.exports